import { useNavigate } from 'react-router-dom'
import { Table, Input } from 'reactstrap'
import { enterKeyHandler } from '../../../utils'
import useForm from '../../CustomHooks/FormHook'
import '../Custom.css'
import CustomSelectListInput from '../CustomSelectListInput'
import { initialFormValues, submitFormValues } from '../CustomUtils'
import FormHeading from '../FormHeading'
import FormSubmitButton from '../FormSubmitButton'

export default function PlaintiffReportForm({ location }) {
  console.log('PlaintiffReportForm rendered: ', location)

  let init = {
    clientNumber: '',
    claimNumber: '',
    claimStatus: '',
    dismissedSettled: '',
    majorOrMinorDesignation: ''
  }

  const navigate = useNavigate()
  init = initialFormValues('PlaintiffReportForm', navigate, init)
  const { inputs, handleInputChange, handleSubmit } = useForm(init, submitSearch, enterKeyHandler(submitSearch))

  async function submitSearch() {
    submitFormValues('PlaintiffReportForm', navigate, inputs, 'mrg.plaintiff_report')
  }

  return (
    <div className="custom-scroll">
      <form className="form" onSubmit={handleSubmit} style={{ maxWidth: '700px', margin: '20px auto' }}>
        <div>
          <Table bordered className="custom-table custom-form-table" style={{ backgroundColor: 'white' }}>
            <FormHeading headingText="Plaintiff Report" />
            <tbody>
              <CustomSelectListInput dataCy='client-number' label="Client Number" handleChange={handleInputChange} modelName="AAG" entityName="client_number" name='clientNumber' blankOption={true} defaultValue={inputs.clientNumber} />
              <CustomSelectListInput dataCy='claim-number' label="Claim Number" handleChange={handleInputChange} modelName="AAG" entityName="claim_number" name='claimNumber' blankOption={true} defaultValue={inputs.claimNumber} />
              <CustomSelectListInput dataCy='claim-status' label="Claim Status" handleChange={handleInputChange} modelName="AAG" entityName="claim_status" name='claimStatus' blankOption={true} defaultValue={inputs.claimStatus}/>
              <tr>
                <td style={{ verticalAlign: 'middle' }}><b>Dismissed/Settled</b></td>
                <td><Input
                  type="select"
                  name="dismissedSettled"
                  onChange={handleInputChange}
                  style={{ width: 'auto', display: 'inline-block', marginRight: '5px' }}
                  defaultValue={inputs.dismissedSettled}
                  data-cy='dismissed'
                >
                  <option value={''}></option>
                  <option value={0}>Is Null</option>
                  <option value={1}>Is Not Null</option>
                </Input></td>
              </tr>
              <tr>
                <td style={{ verticalAlign: 'middle' }}><b>Major or Minor Designation</b></td>
                <td><Input
                  type="select"
                  name="majorOrMinorDesignation"
                  onChange={handleInputChange}
                  style={{ width: 'auto', display: 'inline-block', marginRight: '5px' }}
                  defaultValue={inputs.majorOrMinorDesignation}
                  data-cy='designation'
                >
                  <option value={''}></option>
                  <option value={'Y'}>Yes</option>
                  <option value={'N'}>No</option>
                </Input></td>
              </tr>
            </tbody>
          </Table>
        </div>
        <FormSubmitButton />
      </form>
    </div>
  )
}

